import React from "react";
import CesiumMap from "./CesiumMap";
import MapboxMap from "./MapboxMap";

const Map = ({ mapStyle, ...props }) => {
  if (mapStyle === "cesium" || mapStyle === "cesium-rendering") {
    return (
      <div className="h-full w-full overflow-hidden">
        <CesiumMap mapStyle={mapStyle} {...props} />
      </div>
    );
  }
  return <MapboxMap {...props} />;
};

export default Map;
